import AddSensor from "../dialogs/addSensor"
import AssignGW from "../dialogs/assignGW"
import { fetchWithAuth } from "../auth"
import { useState, useEffect } from 'react';
import '../index.css';

function gf_timestamp(stringtime) {
  const isNumeric = (string) => /^[+-]?\d+(\.\d+)?$/.test(string);
  if (isNumeric(stringtime)) {
    let unix_timestamp = stringtime;
    var a = new Date(unix_timestamp * 1000);

    var month = ("0" + (a.getMonth() + 1)).slice(-2);
    var day = ("0" + a.getDate()).slice(-2);
    var hour = ("0" + a.getHours()).slice(-2);
    var min = ("0" + a.getMinutes()).slice(-2);

    var time = hour + ':' + min + "  " + day + "/" + month;
    return time;
  } else {
    return stringtime;
  }
}

function isAliveBehindMin(tsSec, minutes = 2) {
  const nowMs = Date.now();                // current time in ms
  const tsMs = Number(tsSec) * 1000;       // convert seconds → ms
  return (nowMs - tsMs) > minutes * 60_000;
}

function gf_isAliveBehind(tsSec) {
  return isAliveBehindMin(tsSec, 2) 
    ? isAliveBehindMin(tsSec, 60) 
      ? 'red'
      : '#fef3c7' 
    : '';
}

const Sensors = () => {
  const [sensorsState, setSensorsState] = useState([]);


  // Dialog for adding sensor
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false)
    f_aggiorna()
  };
  const handleOpen = () => {
    setOpen(true)
  };


  // Dialog to assign gateway
  const [openGwAss, setOpenGwAss] = useState(false);
  const [gwAss, setGwAss] = useState('')
  const handleCloseGwAss = () => {
    setOpenGwAss(false)
    f_aggiorna()
  };
  const handleOpenGwAss = (event) => {
    let _id = event.target.getAttribute('id_arg');
    setGwAss(_id)
    setOpenGwAss(true)
  };

  useEffect(() => {
    f_aggiorna();
    const interval=setInterval(()=>{f_aggiorna()}, 60000);
     return()=>clearInterval(interval)
  }, []);

  async function f_aggiorna() {
    await fetchWithAuth('/sensors', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(data => {
        setSensorsState(data);
      })
  }

  function getType(type) {
    switch (type) {
      case 0: return 'Vayyar'
      default: return '?'
    }
  }

  async function f_elimina(event) {
    let _id = event.target.getAttribute('id_arg');
    console.log(_id)
    await fetchWithAuth('/sensor', {
      method: 'DELETE',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ id: _id })
    })
      .then(data => {
        f_aggiorna()
      })
  }


  return (
    <div>
      <AddSensor isOpen={open} onClose={handleClose} />
      <AssignGW isOpen={openGwAss} onClose={handleCloseGwAss} idSensor={gwAss} />
      <h1>Sensori</h1>
      <a href="/">
        <button>Back</button>
      </a>
      <button onClick={f_aggiorna}>aggiorna</button>
      <br /><br /><br />
      <button type="button" onClick={handleOpen}>
        Aggiungi sensore
      </button>


      <table>
        <tbody>
          <tr>
            <th className="title">Id</th>
            <th className="title">Tipo</th>
            <th className="title">Gateway</th>
            <th className="title">Alive</th>
            <th style={{ borderBottom: 'hidden', borderTop: 'hidden', borderRight: 'hidden' }}></th>
            <th style={{ borderBottom: 'hidden', borderTop: 'hidden', borderRight: 'hidden' }}></th>
          </tr>
          {sensorsState.map(mapS => (
            <tr key={mapS.id}>
              <td>{mapS.id}</td>
              <td>{getType(mapS.type)}</td>
              <td>{mapS.serial}</td>
              <td style={{ backgroundColor: gf_isAliveBehind(mapS.alive) }}>{gf_timestamp(mapS.alive)}</td>
              <td style={{ borderBottom: 'hidden', borderTop: 'hidden', borderRight: 'hidden' }}>
                <button onClick={handleOpenGwAss} id_arg={mapS.id}>assegna GW</button>
              </td>
              <td style={{ borderBottom: 'hidden', borderTop: 'hidden', borderRight: 'hidden' }}>
                <button onClick={f_elimina} id_arg={mapS.id}>elimina</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Sensors;
